import TickSuccess from "./tick-success.json";
import Rocket from "./rocket.json";

export default { TickSuccess, Rocket };
